const apiUrl = process.env.GATSBY_API_URL;

const safeJson = async (response) => {
  const text = await response.text();
  if (text === '') return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
};

const request = async ({ path, method = 'GET', body, accessToken }) => {
  if (!apiUrl) {
    throw new Error('Missing GATSBY_API_URL');
  }

  const res = await fetch(`${apiUrl}${path}`, {
    method,
    headers: {
      ...(body ? { 'Content-Type': 'application/json' } : {}),
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await safeJson(res);

  if (!res.ok) {
    const message =
      data?.errors?.[0]?.message || data?.error?.message || res.statusText;
    const error = new Error(message);
    error.status = res.status;
    error.data = data;
    throw error;
  }

  return data;
};

export const directusLogin = async ({ email, password }) => {
  const data = await request({
    path: '/auth/login',
    method: 'POST',
    body: { email, password },
  });

  return {
    accessToken: data?.data?.access_token,
    refreshToken: data?.data?.refresh_token,
    expires: data?.data?.expires,
  };
};

export const directusRefresh = async ({ refreshToken }) => {
  const data = await request({
    path: '/auth/refresh',
    method: 'POST',
    body: { refresh_token: refreshToken },
  });

  return {
    accessToken: data?.data?.access_token,
    refreshToken: data?.data?.refresh_token,
    expires: data?.data?.expires,
  };
};

export const directusLogout = async ({ refreshToken }) => {
  if (!refreshToken) return;
  await request({
    path: '/auth/logout',
    method: 'POST',
    body: { refresh_token: refreshToken },
  });
};

export const directusMe = async ({ accessToken }) => {
  const data = await request({
    path: '/users/me',
    method: 'GET',
    accessToken,
  });

  return data?.data;
};

export const directusRegister = async ({
  email,
  password,
  firstName,
  lastName,
}) => {
  await request({
    path: '/users/register',
    method: 'POST',
    body: {
      email,
      password,
      first_name: firstName,
      last_name: lastName,
    },
  });
};
